<template>
    <div class="product-h6">
        <div class="item-one">
            <img src="../../../assets/img/product/hy1.jpg" alt="">
        </div>
        <div class="item-one">
            <img src="../../../assets/img/product/hy2.jpg" alt="">
        </div>
        <div class="item-one">
            <img src="../../../assets/img/product/hy3.jpg" alt="">
        </div>
		<div class="item-one">
			<img src="./hy/2.jpg" alt="">
		</div>
    </div>
</template>

<script>
    export default {
        name: "ProductOne"
    }
</script>

<style scoped>
    .product-h6 {
        clear: both;
        background-color: #fff;
        width: 100%;
    }
    .product-h6 .item-one{
        width: 100%;
        height: auto;
    }
    .product-h6 .item-one img{
        width: 100%;
        height: auto;
    }
</style>